function makeSnippet(text, query, radius = 40) {
  const lower = text.toLowerCase();
  const q = query.toLowerCase();
  const i = lower.indexOf(q);
  if (i < 0) {
    return text.length > 80 ? `${text.slice(0, 80)}…` : text;
  }
  const start = Math.max(0, i - radius);
  const end = Math.min(text.length, i + q.length + radius);
  return `${start > 0 ? '…' : ''}${text.slice(start, end)}${end < text.length ? '…' : ''}`;
}

function includesQuery(text, query) {
  return typeof text === 'string' && text.toLowerCase().includes(query);
}

/**
 * Scan published play JSON for a substring. Empty query returns no hits.
 * Branch titles are not listed as their own rows; only step and answer text.
 * @param {object|null} playJson
 * @param {string} query
 * @returns {{ branchTitle: string, stepIndex: number, snippet: string }[]}
 */
export function searchPlayJson(playJson, query) {
  const q = (query || '').trim().toLowerCase();
  if (!q || !playJson || !playJson.branches || typeof playJson.branches !== 'object') {
    return [];
  }

  const hits = [];
  Object.entries(playJson.branches).forEach(([branchTitle, branch]) => {
    const steps = Array.isArray(branch && branch.steps) ? branch.steps : [];
    steps.forEach((step, i) => {
      const stepIndex = step && step.index != null ? step.index : i;
      if (includesQuery(step && step.text, q)) {
        hits.push({
          branchTitle,
          stepIndex,
          snippet: makeSnippet(step.text, q),
        });
      }
      const answers = Array.isArray(step && step.answers) ? step.answers : [];
      answers.forEach((answer) => {
        if (includesQuery(answer && answer.text, q)) {
          hits.push({
            branchTitle,
            stepIndex,
            snippet: makeSnippet(answer.text, q),
          });
        }
      });
    });
  });

  return hits;
}
